import * as React from "react"
import { Flex, Text } from "@chakra-ui/react"
import { ChatStyles } from "./index"
import styled from "@emotion/styled"
import { convertMessage } from "../../../util/convert-message"

interface ChatMessageTextProps {
  isTransparent: boolean
  isApproved?: boolean
  message: string
  hovered: boolean
  isReplyText?: boolean
  styleschat: ChatStyles
  isMobile: boolean
  textStyle?: React.CSSProperties
}

interface StyledProps {
  linkcolor: string
}

const MessageText = styled(Text)<StyledProps>`
  > a {
    color: ${({ linkcolor }) => `${linkcolor} !important`};
  }
`

const _ChatMessageText: React.FC<ChatMessageTextProps> = ({
  isTransparent,
  message,
  hovered,
  isReplyText,
  styleschat,
  isMobile,
  textStyle
}) => {
  const textColor = React.useMemo(() => {
    if (isTransparent) {
      return "white"
    }
    return styleschat?.servicePanelElementPrimaryText ?? "#2D3748"
  }, [isTransparent, styleschat?.servicePanelElementPrimaryText])

  return (
    <Flex
      opacity={hovered ? "0.2" : "1"}
      whiteSpace="pre-wrap"
      paddingRight={isTransparent && "0.33rem"}
    >
      <MessageText
        lineHeight={1.2}
        fontSize={isMobile ? "1rem" : "0.875rem"}
        color={textColor}
        linkcolor={textColor}
        wordBreak="break-word"
        style={textStyle}
      >
        {convertMessage(message)}
      </MessageText>
    </Flex>
  )
}

export const ChatMessageText = React.memo(_ChatMessageText)
